module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-ro-folder-view"
  }, [_c('h2', {
    staticClass: "ro-folder-view__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "ro-folder-view__container"
  }, [(_vm.openFolders && _vm.openFolders.length) ? _c('div', {
    staticClass: "ro-folder-view__breadcrumbs"
  }, _vm._l((_vm.openFolders), function(folder, index) {
    return _c('span', {
      key: index,
      class: [
        'ro-folder-view__breadcrumbs__title',
        {
          'ro-folder-view__breadcrumbs__title--current': folder.name === _vm.currentItems.name,
        } ],
      attrs: {
        "tabindex": 0,
        "aria-label": ('Gå til', folder.name),
        "role": "button"
      },
      on: {
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
          _vm.goToFolder(index)
        },
        "click": function($event) {
          _vm.goToFolder(index)
        }
      }
    }, [_vm._v(_vm._s(folder.name) + "\n\n        "), (index < _vm.openFolders.length - 1) ? _c('span', {
      staticClass: "ro-folder-view__breadcrumb__seperator"
    }, [_vm._v("\n          >\n        ")]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.currentItems && _vm.currentItems.children.length) ? _c('ul', _vm._l((_vm.currentItems.children), function(item, index) {
    return _c('li', {
      key: (index, item.name),
      ref: "folderListItem",
      refInFor: true,
      staticClass: "ro-folder-view__item",
      attrs: {
        "tabindex": 0,
        "aria-label": item.name,
        "title": item.size ? _vm.formattedFileSize(item.size) : null,
        "role": item.children ? 'button' : 'link'
      },
      on: {
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
          _vm.selectFolder(item)
        },
        "click": function($event) {
          _vm.selectFolder(item)
        }
      }
    }, [_c('sky-svg', {
      staticClass: "ro-folder-view__icon",
      attrs: {
        "name": item.url ? 'file' : 'folder'
      }
    }), _vm._v("\n\n        " + _vm._s(item.name) + "\n      ")], 1)
  })) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-940689b8"}!/Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./scripts/ro-folder-view/RoFolderView.vue
// module id = 382
// module chunks = 1